import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { profileAccountService } from "../../store/actions";
import { common } from "../../store/slicer/common";

interface VerificationResponse {
  userData: {
    address: string;
    name: string | null;
    email: string;
    telegram_id: string | null;
  };
}

interface VerificationStatus {
  isVerified: boolean;
  timestamp: number;
  address: string;
}

export const useVerification = () => {
  const dispatch = useDispatch();
  const _account = useSelector((e: Object) => (e as any)?.common?.account);
  const verificationStatus = useSelector(
    (e: Object) => (e as any)?.common?.verificationStatus
  );

  useEffect(() => {
    if (
      verificationStatus &&
      _account?.address &&
      verificationStatus.address !== _account.address
    ) {
      dispatch(common.actions.actionVerificationStatus(null));
    }
  }, [_account?.address, verificationStatus, dispatch]);

  const verifyAndCheckAccess = async (): Promise<boolean> => {
    try {
      if (!_account?.message || !_account?.signature) {
        return false;
      }

      
      if (
        verificationStatus &&
        verificationStatus.isVerified &&
        verificationStatus.address === _account.address &&
        Date.now() - verificationStatus.timestamp < 24 * 60 * 60 * 1000
      ) {
        // 24 hours
        return true;
      }

      const response = await profileAccountService.getVerified({
        message: _account.message,
        signature: _account.signature,
      });

      const data = response as VerificationResponse;

      if (!data?.userData?.address || !data?.userData?.email) {
        return false;
      }

     
      const status: VerificationStatus = {
        isVerified: true,
        timestamp: Date.now(),
        address: _account.address,
      };
      dispatch(common.actions.actionVerificationStatus(status));

      return true;
    } catch (error) {
      console.error("Verification failed:", error);
      return false;
    }
  };

  const clearVerificationStatus = () => {
    dispatch(common.actions.actionVerificationStatus(null));
  };

  return {
    verifyAndCheckAccess,
    clearVerificationStatus,
    isVerified: verificationStatus?.isVerified || false,
  };
};
